import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	notiItems: []
}

const notificationsSlice = createSlice({
	name: 'notifications',
	initialState,
	reducers: {
		setNotifications: (state, { payload }) => {
			state.notiItems = payload
		},
		clearAll: state => {
			state.notiItems = []
		},
		removeNotification: (state, { payload }) => {
			state.notiItems = state.notiItems.filter(item => item.runId !== payload)
		}
	}
})

export const { setNotifications, clearAll, removeNotification } =
	notificationsSlice.actions

export default notificationsSlice.reducer
